module.exports = __webpack_public_path__ + "img/paoduct1.413ec14a.png";